exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comment-user[data-v-7554852c]{\n    font-size: 15px;\n    font-weight: 500;\n}\n.comment-timelapsed[data-v-7554852c]{\n    margin-left: 10px;\n    color: #247673;\n}\n.comment-body[data-v-7554852c]{\n    margin-top: 10px;\n    text-align: justify;\n}\n#paginationNum[data-v-7554852c] {\n    width: 3.5vw;\n    border: none;\n    text-align: center;\n    background: #fff;\n    color: #343a40 !important;\n}\n", ""]);

// exports
